import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import segmentReadAction from './segmentRead.action.json' assert { type: 'json' }

const segmentReadDefinition = defineReadAutoAction(segmentReadAction, 'segment')

export default segmentReadDefinition
